var exports = {
  "i": "xaee3c4fa--f19707--wrapper",
  "o": "xaee3c4fa--f19707--content-wrapper",
};

module.exports = exports;
